document.addEventListener("DOMContentLoaded", () => {
  const dropdowns = document.querySelectorAll(".header__inline-menu details");

  dropdowns.forEach((dropdown) => {
    const submenu = dropdown.querySelector(".header__submenu");

    dropdown.addEventListener("mouseenter", () => {
      dropdown.setAttribute("open", true);
    });

    dropdown.addEventListener("mouseleave", () => {
      dropdown.removeAttribute("open");
    });
  });
});
